import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminMarketingToolRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/marketing_tools/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/admin/MarketingTools/AdminMarketingToolPage/AdminMarketingToolPage').then(
    (d) => d.Route
  )
);
